import { useSelector } from "react-redux";

const escapeRegExpCharacters = (value) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const normalizeWhitespace = (value) =>
  String(value)
    .replace(/\u00A0/g, " ")
    .replace(/\s+/g, " ");

export const Highlight = ({ hit, attribute }) => {
  const { query: searchQuery } = useSelector((state) => state.searcher);
  const attributeValue = hit?.[attribute];

  if (!attributeValue || !searchQuery) {
    return <span>{attributeValue}</span>;
  }

  const normalizedText = normalizeWhitespace(attributeValue);
  const normalizedQuery = normalizeWhitespace(searchQuery).trim();

  if (!normalizedQuery) {
    return <span>{attributeValue}</span>;
  }

  const queryTokens = Array.from(
    new Set(normalizedQuery.split(" ").filter(Boolean))
  );

  if (queryTokens.length === 0) {
    return <span>{attributeValue}</span>;
  }

  // Ordenamos por longitud descendente para evitar solapamientos raros
  const sortedTokensByLength = queryTokens.sort(
    (a, b) => b.length - a.length
  );

  const highlightPattern = new RegExp(
    `(${sortedTokensByLength
      .map(escapeRegExpCharacters)
      .join("|")})`,
    "gi"
  );

  const textSegments = normalizedText.split(highlightPattern);

  return (
    <span>
      {textSegments.map((segment, index) =>
        index % 2 === 1 ? (
          <strong key={index}>{segment}</strong>
        ) : (
          segment
        )
      )}
    </span>
  );
};